var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooks1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "books 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 31.2017V4.20166C13 3.64866 12.552 3.20166 12 3.20166H2C1.448 3.20166 1 3.64866 1 4.20166V31.2017H13ZM6 10.2017C6 9.64866 6.448 9.20166 7 9.20166C7.552 9.20166 8 9.64866 8 10.2017V18.2017C8 18.7547 7.552 19.2017 7 19.2017C6.448 19.2017 6 18.7547 6 18.2017V10.2017Z",
    fill: "#A3B96D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 33.2017V44.2017C1 44.7547 1.448 45.2017 2 45.2017H12C12.552 45.2017 13 44.7547 13 44.2017V33.2017H1Z",
    fill: "#A3B96D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27 31.2017V4.20166C27 3.64866 26.552 3.20166 26 3.20166H16C15.448 3.20166 15 3.64866 15 4.20166V31.2017H27ZM20 10.2017C20 9.64866 20.448 9.20166 21 9.20166C21.552 9.20166 22 9.64866 22 10.2017V18.2017C22 18.7547 21.552 19.2017 21 19.2017C20.448 19.2017 20 18.7547 20 18.2017V10.2017Z",
    fill: "#A3B96D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15 33.2017V44.2017C15 44.7547 15.448 45.2017 16 45.2017H26C26.552 45.2017 27 44.7547 27 44.2017V33.2017H15Z",
    fill: "#A3B96D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.3438 33.4756L34.9868 44.3516C35.0608 44.8466 35.4878 45.2016 35.9738 45.2016C36.0238 45.2016 36.0738 45.1976 36.1248 45.1906L46.0128 43.6976C46.2748 43.6576 46.5108 43.5146 46.6678 43.3016C46.8258 43.0876 46.8918 42.8216 46.8518 42.5586L45.2088 31.6826L33.3438 33.4756Z",
    fill: "#A3B96D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.9094 29.7046L40.8764 3.00763C40.7944 2.46163 40.2864 2.09263 39.7384 2.16763L29.8504 3.66063C29.5884 3.70063 29.3524 3.84363 29.1954 4.05663C29.0374 4.27063 28.9714 4.53663 29.0114 4.79963L33.0444 31.4966L44.9094 29.7046ZM35.6904 8.84763C36.2374 8.77263 36.7464 9.14163 36.8284 9.68763L38.0234 17.5976C38.1064 18.1436 37.7304 18.6536 37.1844 18.7366C37.1334 18.7436 37.0834 18.7476 37.0334 18.7476C36.5474 18.7476 36.1204 18.3926 36.0464 17.8966L34.8514 9.98663C34.7694 9.43963 35.1454 8.93063 35.6904 8.84763Z",
    fill: "#A3B96D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks1);
export default __webpack_public_path__ + "static/media/books 1.107215a2f260b32ad3f2bcee8a44a79d.svg";
export { ForwardRef as ReactComponent };